__turbopack_context__.v({
  "calculator_cta": "styles-module-scss-module__ZIuAsa__calculator_cta",
  "chart_wrapper": "styles-module-scss-module__ZIuAsa__chart_wrapper",
  "condensed": "styles-module-scss-module__ZIuAsa__condensed",
  "cta_wrapper": "styles-module-scss-module__ZIuAsa__cta_wrapper",
  "hide_visual": "styles-module-scss-module__ZIuAsa__hide_visual",
  "legend_color": "styles-module-scss-module__ZIuAsa__legend_color",
  "legend_container": "styles-module-scss-module__ZIuAsa__legend_container",
  "legend_item": "styles-module-scss-module__ZIuAsa__legend_item",
  "legend_label": "styles-module-scss-module__ZIuAsa__legend_label",
  "legend_value": "styles-module-scss-module__ZIuAsa__legend_value",
  "ownership": "styles-module-scss-module__ZIuAsa__ownership",
  "rental": "styles-module-scss-module__ZIuAsa__rental",
  "results_header": "styles-module-scss-module__ZIuAsa__results_header",
  "savings_amount": "styles-module-scss-module__ZIuAsa__savings_amount",
  "savings_display": "styles-module-scss-module__ZIuAsa__savings_display",
  "savings_period": "styles-module-scss-module__ZIuAsa__savings_period",
  "select_wrapper": "styles-module-scss-module__ZIuAsa__select_wrapper",
  "tooltip_header": "styles-module-scss-module__ZIuAsa__tooltip_header",
  "tooltip_row": "styles-module-scss-module__ZIuAsa__tooltip_row",
  "tooltip_summary": "styles-module-scss-module__ZIuAsa__tooltip_summary",
});
